module.exports = __webpack_public_path__ + "img/dark-check.63781733.svg";